<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    name="fee_valid_from"
    :label="'Validity'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="7"
    :labelAlign="labelAlign"
    :helpTooltip="'The validity period of the fee.'|pgettext('ContractServiceFee|Tooltip')"
    contentClass="form-row"
  >
    <DIV
      class="col"
    >
      <ItpFormDatetime
        name="valid_from"
        v-model="item.valid_from"
        required
      >
      </ItpFormDatetime>
    </DIV>
    <DIV
      class="col"
    >
      <ItpFormDatetime
        name="valid_to"
        v-model="item.valid_to"
      >
      </ItpFormDatetime>
    </DIV>
    <div
      slot="description"
    >
      <span>
        {{ 'The start date is required. Set the end date only if different from the end of the service.'|pgettext('ContractServiceFee|Tooltip') }}
      </span>
    </div>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_valid_to"
    :label="'Amount'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="5"
    :labelAlign="labelAlign"
    contentClass="input-group"
    :helpTooltip="'The price per unit of the fee.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormInput
      mask="number"
      unmask="typed"
      name="fee_amount"
      scale="4"
      v-model="item.amount"
      required
      class="col-9"
    >
    </ItpFormInput>
    <ItpFormSelect
      name="currency"
      v-model="item.currency"
      :options="currencies"
      textField="code"
      valueField="code"
      required
      class="col-3"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_unit"
    :label="'Invoice unit'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="2"
    :labelAlign="labelAlign"
    contentClass="input-group"
    :helpTooltip="'The unit used for billing.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormInput
      name="fee_unit"
      v-model="item.unit"
      required
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_quantity"
    :label="'Quantity'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="2"
    :labelAlign="labelAlign"
    contentClass="input-group"
    :helpTooltip="'The quantity to bill for each period.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormInput
      type="number"
      name="fee_quantity"
      v-model="item.quantity"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_unit_of_quantity"
    :label="'Unit of quantity'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="2"
    :labelAlign="labelAlign"
    contentClass="input-group"
    :helpTooltip="'The unit of quantity - if different from the billing quantity.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormInput
      name="fee_unit_of_quantity"
      v-model="item.unit_of_quantity"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_inflation_indexed"
    :label="'Inflation indexed'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="9"
    :labelAlign="labelAlign"
    :helpTooltip="'Indicates if the unit price should be automatically adjusted based on indexation rules.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormCheckbox
      name="fee_inflation_indexed"
      v-model="item.inflation_indexed"
    >
    </ItpFormCheckbox>
  </ItpFormGroup>
  <ItpFormGroup
    name="transaction_notes"
    :label="'Invoice notes'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="9"
    :labelAlign="labelAlign"
    :helpTooltip="'Note to display on the invoice line.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <TransactionNotesEditor
      v-model="item.transaction_notes"
    >
    </TransactionNotesEditor>
  </ItpFormGroup>
  <ItpFormGroup
    name="fee_notes"
    :label="'Notes'|pgettext('ContractServiceFee')"
    labelColsMd="3"
    contentColsMd="9"
    :labelAlign="labelAlign"
    :helpTooltip="'Notes for internal use only.'|pgettext('ContractServiceFee|Tooltip')"
  >
    <ItpFormTextarea
      name="fee_notes"
      v-model="item.notes"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetContractServiceFee extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  ux!: any;
  dataMembers = ['currencies', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        currencies: null,
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9094: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9093: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9094 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9093 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9094,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9093],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9094,
      evh_7315092382398562_reload_9093,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("FieldsetContractServiceFee", FieldsetContractServiceFee);

</script>